import anime from 'animejs';
import 'waypoints/lib/noframework.waypoints.min.js';

const swooshElements = [...document.querySelectorAll('.js-swoosh')];

swooshElements.forEach(function applyTheSwoosh(swooshElement) {
  const swooshness = anime({
    targets: swooshElement,
    keyframes: [{ translateY: 50, opacity: 0 }, { translateY: 0, opacity: 1 }],
    duration: 750,
    easing: 'linear',
    autoplay: false,
  });

  const waypoint = new Waypoint({
    element: swooshElement,
    offset: '75%',
    handler() {
      swooshness.play();
      waypoint.destroy();
    },
  });
});
